import React, { Component } from 'react';
import { connect } from 'react-redux';
import BalanceView from './Balance.view';

export class BalanceContainer extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_BALANCE'
    });
  }

  render() {
    return (<BalanceView
      {...this.state}
      {...this.props}
    />);
  }

}

function mapStateToProps(state) {
  const { balance } = state;
  return {
    ...balance,
  };
}

export default connect(mapStateToProps)(BalanceContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Balance/Balance.container.js